export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7256.11af0041.jpg";